import { render } from "./RadioCard.vue?vue&type=template&id=5313b8b8&scoped=true"
import script from "./RadioCard.vue?vue&type=script&lang=js"
export * from "./RadioCard.vue?vue&type=script&lang=js"

import "./RadioCard.vue?vue&type=style&index=0&id=5313b8b8&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5313b8b8"]])

export default __exports__